<script setup>
import { computed } from "vue";
import { useStore } from "vuex";
import ImageReviewButton from "./ImageReviewButton.vue";

const emit = defineEmits(["cancel"]);
const store = useStore();
const status = computed(() => store.getters["loading/uploadArtworkStatus"]);
const percentage = computed(() =>
  parseFloat(store.getters["loading/uploadArtworkProgress"]).toFixed(2)
);
</script>

<template>
  <div class="image-review-enhancing">
    <div class="image-review-enhancing__buttons">
      <ImageReviewButton skin="border" icon="loader" disabled="disabled">
        Enhancing the image
      </ImageReviewButton>

      <ImageReviewButton skin="gray" @click="emit('cancel')">Cancel</ImageReviewButton>
    </div>

    <div class="image-review-enhancing__loading">
      <div class="image-review-enhancing__loading-runner" :style="{ width: `${percentage}%` }" />
    </div>

    <div class="image-review-enhancing__percentage">
      <b>{{ `${percentage}%` }}</b> ({{ status.message }})
    </div>
  </div>
</template>

<style scoped lang="scss">
@import "frontend/init/pod/settings";

.image-review-enhancing {
  &__buttons {
    display: grid;
    grid-template-columns: 1fr 87px;
    gap: 12px;
    max-width: 320px;
    margin: 0 auto 16px;
  }

  &__loading {
    background-color: $pod-gray-modern-100;
    margin: 0 auto 8px;
    max-width: 263px;
    border-radius: 2px;
    height: 4px;
    overflow: hidden;
  }

  &__loading-runner {
    background: $pod-brand-gradient;
    background-position: 100% 100%;
    height: 100%;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
  }

  &__percentage {
    font-family: sans-serif;
    text-align: center;
    font-size: 16px;
    line-height: 1;
    color: $pod-gray-modern-800;
  }
}
</style>
